import { createSelector } from '@reduxjs/toolkit';
import { selectBedrooms } from 'shared/selectors/jsonQuery';
import { selectBedroomsLabel } from './selectBedroomsLabel';

export const selectBedroomsFilter = createSelector([selectBedrooms, selectBedroomsLabel], (value, label) => {
  const { gte: min = null, lte: max = null } = value || {};

  return {
    label,
    value: { min, max },
  };
});
